import { useQuery } from "@tanstack/react-query";
import { photoSeriesGet } from "common/api/citajteo/photo_series/photo_series";
import { QUERY_KEYS } from "constant/react_query";
import { PhotoSeries } from "model/photo_series/PhotoSeries";

export const usePhotoSeriesGet = (
  id: string,
  searchBy: string = "id"
): PhotoSeries | null => {
  const { data: photoSeries } = useQuery(
    [QUERY_KEYS.CITAJTEO_PHOTO_SERIES_GET, id, searchBy],
    async () => {
      const result = await photoSeriesGet(id, searchBy);
      return result;
    },
    { staleTime: Infinity, enabled: id !== "" }
  );
  const result =
    typeof photoSeries !== "undefined" && photoSeries !== "" ? photoSeries : null;
  return result;
};
